export default __webpack_public_path__ + "static/cxa_ilija_bojchovikj-3951b595feb77f1ab17be76812ad9363.png";